import { MAX_ITEMS_IN_PAGE } from "../../actions/commonActions";

const initState = {
  users: [],
  otp: "",
  user: {
    roles: [],
  },
  currentUser: {},
  defaultUserRole: "",
  login: {},
  resetPassword: {},
  resendVerification: {},
  supervisors: [],
  projectManagers: [],
  projectSponsors: [],
  loggingIn: false,
  resettingPassword: false,
  resendingVerificationCode: false,
  currentPage: 1,
  totalPages: 0,
  numItems: 0,
  min: 1,
  max: MAX_ITEMS_IN_PAGE,
};

const usersReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_USERS":
      return {
        ...state,
        users: action.users,
      };
    case "USERS_SET_FIELD_VALUE":
      return {
        ...state,
        user: Object.assign(state.user, action.value),
      };
    case "RESET_USER":
      return {
        ...state,
        user: {},
      };
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };
    case "SET_CURRENT_USER":
      return {
        ...state,
        currentUser: action.user,
      };
    case "SET_LOGGING_IN":
      return {
        ...state,
        loggingIn: action.loggingIn,
      };
    case "FETCH_SUPERVISORS":
      return {
        ...state,
        supervisors: action.supervisors,
      };
    case "FETCH_PROJECT_MANAGERS":
      return {
        ...state,
        projectManagers: action.projectManagers,
      };
    case "FETCH_PROJECT_SPONSORS":
      return {
        ...state,
        projectSponsors: action.projectSponsors,
      };
    case "FETCH_SUBORDINATES":
      return {
        ...state,
        subordinates: action.subordinates,
      };
    case "USER_LOGIN_FIELD_VALUE":
      return {
        ...state,
        login: Object.assign(state.login, action.value),
      };
    case "USER_RESET_PASSWORD_FIELD_VALUE":
      return {
        ...state,
        resetPassword: Object.assign(state.resetPassword, action.value),
      };
    case "USER_RESEND_VERIFICATION_FIELD_VALUE":
      return {
        ...state,
        resendVerification: Object.assign(
          state.resendVerification,
          action.value
        ),
      };
    case "SET_DEFAULT_ROLE":
      return {
        ...state,
        defaultUserRole: action.role,
      };
    case "USER_FILTER":
      return {
        ...state,
        userFilter: action.filter,
      };
    case "CLEAR_USERS":
      return {
        ...state,
        users: [],
      };
    case "SET_RESETTING_PASSWORD":
      return {
        ...state,
        resettingPassword: action.resettingPassword,
      };
    case "SET_VERIFICATION_CODE":
      return {
        ...state,
        resendingVerificationCode: action.resendingVerificationCode,
      };
    case "SET_USERS_PAGINATION":
      return {
        ...state,
        numItems: action.numItems,
        min: action.min,
        totalPages: action.totalPages,
        currentPage:
          typeof action.currentPage !== "undefined"
            ? action.currentPage
            : state.currentPage,
        max: action.max,
      };
    case "RESET_USERS_PAGINATION":
      return {
        ...state,
        currentPage: 1,
        totalPages: 0,
        numItems: 0,
        min: 1,
        max: MAX_ITEMS_IN_PAGE,
      };
    case "SET_USER_OTP":
      return {
        ...state,
        otp: action.otp,
      };
    default:
      return state;
  }
};

export default usersReducer;
